import {Injectable} from '@angular/core';
import {pluckResult, ProductManagementApiService} from './product-management-api.service';
import {HttpClient} from '@angular/common/http';
import {Variation} from '@sportngin/se-commerce-sdk/models/clare';
import {environment} from '../../environments/environment';
import {ApiResponse} from '../models/clare';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class VariationApiService extends ProductManagementApiService {
  controllerPath = 'item_variations';

  constructor(protected override http: HttpClient) {
    super(http);
  }

  update(variation: Partial<Variation>): Observable<Variation> {
    const endpoint = `${variation.id}`;
    const url = this.getUrl(endpoint);
    return this.PATCH<ApiResponse<Variation>>(url, variation, this.requestOptions()).pipe(pluckResult());
  }

  protected override getUrl(path = ''): string {
    return `${environment.clareApiUrl}/${this.controllerPath}/${path}`;
  }
}
